import { useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';

import { useApi, useFetchData } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';
import Dialog from '@app/components/common/modals/dialog';
import { Employee } from '@app/api/models/structure';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';
import Error404 from '@app/pages/errors/404';

import { EmployeesForm } from './form';
import { useColumns } from './columns';

export const EmployeesTable = () => {
  const api = useApi();
  const [fetchData] = useFetchData<Employee>({ method: api.structure.getEmployees });
  const [selectedEmployee, setSelectedEmployee] = useState<Employee>();
  const [modal, setModal] = useState<'add' | 'edit' | 'remove' | null>(null);
  
  const hasPermission = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF] });

  const columns = useColumns({
    onEdit: (item: Employee) => {
      setSelectedEmployee(item);
      setModal('edit');
    }
  });

  const onFormSubmit = async (instance: Employee) => {
    setModal(null);
  };

  if (!hasPermission) {return <Error404/>;}

  return <>  
    <QueryTable<Employee>
      title="Сотрудники"
      columns={columns}
      fetchData={fetchData}
      onCreateClick={() => {
        setSelectedEmployee(undefined);
        setModal('add');
      }}
    >
      <Dialog open={modal === 'edit' || modal === 'add'}
        onClose={() => setModal(null)}
        title={modal === 'edit' ? 'Редактирование' : 'Добавление'}
        width={800}
      >
        <EmployeesForm
          initial={modal === 'edit' ? selectedEmployee : undefined}
          onSubmit={onFormSubmit}
          onCancel={() => setModal(null)}
        />
      </Dialog>
    </QueryTable>
  </>;
};